import React, { useEffect, useState } from "react"
import { Box } from "@rebass/grid/emotion"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import useQueryParam from "../../../../hooks/useIsQueryParam"
import SubscriptionIncludes from "../atc/subscriptionincludes/subscriptionincludes"
import SubscriptionOptions from "../atc/subscriptionoptions/subscriptionoptions-nova"
import GwpAtcCardMulti from "../gwp/gwpatcarea/gwpatccardmulti"

import { readCookie } from "../../../../utils/cookies"

import {
  AltContentsContainer,
  ButtonsWrap,
  BuyOnce,
  RadioHolder,
} from "./pdp-atc.styled"

const atcText = "Add to Cart"
const upsellSkus = [`WOM1-S01`, `POS1-S01`, `VEG1-S01`, `BAL1-S01`]
const variantSku = `BAL3-S01`

const PdpAtcRadio = (props) => {
  const { atcData, activeOption, setActiveOption } = props.state
  const { atcCard } = props
  const { handleGwpModal } = props
  const source = props.data?.purchase_source || "pdp"
  const upsellCallback = props.upsellCallback
  const [isFloat, setIsFloat] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [hasProductBeenSelected, setHasProductBeenSelected] = useState(false)
  const [triggerSelection] = useQueryParam()
  //const variant = useVariant("bal3mupsell")

  useEffect(() => {
    // add this cookie to charge shipping
    document.cookie = "atc_test=group_1;path=/;secure"
  }, [])

  useEffect(() => {
    if (typeof document !== "undefined") {
      const handleClick = (evt) => {
        evt = evt || window.event
        if (
          Array.from(evt.target.classList).indexOf("buttonsfloat") === -1 &&
          isFloat
        ) {
          setIsFloat(false)
        }
      }
      const handleKey = function (evt) {
        evt = evt || window.event
        var isEscape =
          evt &&
          (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27)
        if (isEscape) {
          if (isFloat) {
            setIsFloat(false)

            const header = document.querySelector("header")
            const main = document.querySelector("main")
            const footer = document.querySelector("footer")

            header && header.setAttribute("data-mousedown", "1")
            main && main.setAttribute("data-mousedown", "1")
            footer && footer.setAttribute("data-mousedown", "1")
          }
        }
      }
      document.addEventListener("click", handleClick)
      document.addEventListener("keydown", handleKey)
      return () => {
        document.removeEventListener("click", handleClick)
        document.removeEventListener("keydown", handleKey)
      }
    }
  }, [isFloat])

  if (atcData === null) {
    return null
  }

  const options = atcData.options

  if (!options) {
    return null
  }

  triggerSelection(options, activeOption, setActiveOption)

  const atcClick = (e, idx) => {
    if (isSubmitted) {
      return
    }
    //NT2-22507
    const variant = window.bal3mupsell
    if (variant && variant !== "control" && !upsellSkus.includes(variantSku)) {
      upsellSkus.push(variantSku)
    }
    const option = idx ? options[idx] : options[activeOption]

    const formatAndSetLocalStorageCart = (ajaxCartResponse) => {
      if (ajaxCartResponse && typeof ajaxCartResponse === "object") {
        let formattedCart = {
          totals: ajaxCartResponse?.[0],
          items: ajaxCartResponse?.[1],
        }
        localStorage.setItem("cart", JSON.stringify(formattedCart))
      }
    }

    if (!isFloat) {
      // fire product selected segment when user adds default option to cart
      if (!hasProductBeenSelected) {
        onSelect(null, option)
      }
      setIsSubmitted(true)

      const code = option?.ui_data?.code

      const url = `${process.env.GATSBY_MAGENTO_URL}dpa/add/tocart/?skus=${
        option.sku
      }&purchase_source=${source}${code ? `&code=${code}` : ""}`
      const queryID = readCookie("queryID")
      const handleUpsellFlow = (cartSku = null) => {
        const useUpsellflow =
          cartSku !== variantSku || ["a", "b"].includes(variant)

        if (useUpsellflow) {
          const body = { skus: option.sku, purchase_source: source }
          if (code) {
            body.code = code
          }
          fetch(
            `${process.env.GATSBY_MAGENTO_URL}rest/V1/repack/add_to_cart/`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(body),
            }
          )
            .then((res) => res.json())
            .then((resJson) => {
              setIsSubmitted(false)
              formatAndSetLocalStorageCart(resJson)
              upsellCallback(resJson, cartSku, variant)
            })
            .catch((error) => {
              setIsSubmitted(false)
              /*
               * if add to cart ajax fails on BE - making regular DPA redirect
               */
              formatAndSetLocalStorageCart("Quote does not exist.")
              window.location.href = url
              console.error("Error:", error)
            })
        } else {
          setTimeout(() => {
            window.location.href = url
          }, 250)
        }
      }

      const segmentObject = {
        text: atcText,
        name: option.name,
        sku: option.sku,
        price: option.price,
        variant: option?.ui_data?.title,
        product_gender: option.product_gender,
        billing_interval: option.billing_interval,
        core_category: option.product_core_category,
        product_category: option.product_category,
        purchase_type: option.purchase_type,
        shipping_interval: option.shipping_interval,
        quantity: 1,
        quiz_reco: false,
        source: source,
        type: "button",
        index: "Products",
        queryID,
      }

      if (code) {
        segmentObject.coupon = code
      }

      segmentEvent("Product Added", segmentObject)

      /*
       * NT2-23609
       *  Balance PDP | 1oz HS Upsell 3/6-Month Sub | Segment Events
       * see gatsby-browser.js , execute experimentFn on  3-month sub to cart
       */
      const useExperimentFn =
        option.sku === variantSku && typeof window.experimentFn === "function"
      if (useExperimentFn) {
        window.experimentFn()
      }

      if (
        typeof upsellCallback === "function" &&
        upsellSkus.includes(option.sku)
      ) {
        handleUpsellFlow(option.sku)
      } else {
        setTimeout(() => {
          window.location.href = url
        }, 250)
      }
    }
  }

  const onSelect = (idx, product) => {
    const option = product ? product : options[idx]
    setHasProductBeenSelected(true)

    const code = option?.ui_data?.code

    const eventObj = {
      variant: option?.ui_data?.title,
      core_category: option.product_core_category,
      name: option.name,
      sku: option.sku,
      price: option.price,
      product_gender: option.product_gender,
      type: "dropdown",
    }

    if (code) {
      eventObj.coupon = code
    }

    segmentEvent("Product Selected", eventObj)
  }

  return (
    <AltContentsContainer>
      <ButtonsWrap>
        <RadioHolder pt={[40, 40, 32, 40]}>
          <SubscriptionOptions
            options={options.filter((el) => !el.sku?.includes("N01"))}
            setActiveOption={setActiveOption}
            activeOption={activeOption}
          />
        </RadioHolder>
        {atcCard ? (
          <Box
            pt={[16]}
            mb={[-24, null, -16, -24]}
            onClick={handleGwpModal}
            className="cursor-pointer z-10"
          >
            <GwpAtcCardMulti data={atcCard} activeOption={activeOption} />
          </Box>
        ) : null}

        <Box id="atc-button-container" pt={[40, 40, 32, 40]}>
          <ButtonNova
            className={`pdp-main-atc ${
              isFloat || isSubmitted ? "disabled" : ""
            }`}
            width={"100%"}
            icon={"Right"}
            level={"Primary"}
            label={atcText}
            onClick={atcClick}
          />
        </Box>
      </ButtonsWrap>
      {atcData.singleOption ? (
        <BuyOnce className="buy-once" pt={[24]} pb={[24, 24, 32, 24]}>
          <ButtonNova
            level={"Textlink"}
            label={`Buy Once for $88 + $6.95 shipping`}
            className="mx-auto block"
            onClick={(e) => {
              setActiveOption(3)
              onSelect(3)
              atcClick(e, 3)
            }}
          />
          <TextElementNova
            text="We recommend 3-6 months of consistent use to see results."
            element="p"
            className="pt-2 sm:pt-4 Body-10-Dia-Normal text-center text-nova-transparency-black-60"
          />
        </BuyOnce>
      ) : null}
      <Box>
        <SubscriptionIncludes />
      </Box>
    </AltContentsContainer>
  )
}

export default PdpAtcRadio
